/*
 * @Autor: 
 * @Date: 2024-01-11 21:40:26
 * @LastEditTime: 2025-09-17 16:57:10
 * @Description: 
 * @FilePath: \xxci\register\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Register from '@/components/register'
import Update  from '@/components/update'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/register',
      component: Index,
      children: [
        {
          path: 'register',
          name: 'Register',
          component: Register,
        },
        {
          path: 'update',
          name: 'Update',
          component: Update,
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js